"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  userCenter: {
    desktop: 'Desktop',
    center: 'UserCenter',
    await: 'To-Do Tasks',
    authApprove: 'AuthApprove',
    attentionBuz: 'My Favourite',
    attentionShip: 'My Fleet',
    followed: 'Followed',
    unFollowed: 'Unfollowed',
    vesselList: 'Vessel List',
    authTable: {
      authorizer: 'Authorizer',
      authorized: 'Authorized',
      startTime: 'Start Time',
      endTime: 'End Time',
      module: 'Module'
    },
    taskType: 'Task Type',
    emergency: 'Emergency',
    awaitTable: {
      publishTime: 'PublishTime',
      modelName: 'Model Name',
      currNodeStatus: 'Emergency',
      activityName: 'Activity Name',
      remark: 'Remarks',
      toDoDate: 'To Do Date',
      handleType: 'Treatment Type',
      handleDate: 'Handling Time',
      handleOpinion: 'Handling Opinions'
    },
    transferDialog: {
      publishTime: 'Publish Time',
      modelName: 'Model Name',
      activityName: 'Activity Name',
      executionId: 'executionId',
      msgKey: 'Msg Key',
      payload: 'Payload',
      selectUserTile: 'select User',
      selectFromUserTile: 'Select FromUser',
      operationTips: 'Operation Tips'
    },
    buzTable: {
      ship: 'Ship',
      buzModule: 'Module',
      featureInterface: 'FeatureInterface',
      businessPaper: 'Abstract',
      attentionTime: 'Collect Time'
    },
    vesselDashboard: 'Portrait of a single ship(Building)',
    vesselFilter: {
      company: 'Company',
      vesselTeam: 'Vessel Team',
      vesselName: 'Vessel Name',
      vesselCode: 'Vessel Code',
      isFocus: 'Isfocus',
      manager: 'Manager'
    },
    vesselTable: {
      company: 'Company',
      vesselTeam: 'Vessel Team',
      vesselCode: 'Vessel Code',
      vesselName: 'Vessel Name'
    },
    msgList: 'MsgList',
    msgRead: 'MsgRead',
    monitorRemind: 'Monitor Remind',
    msgFilter: {
      messageMode: 'Message Mode',
      messageSubType: 'Message Subtype',
      msgType: 'Msg Type',
      readFlag: 'Isread'
    },
    msgTable: {
      messageType: 'Message Type',
      messageSubject: 'Message Subject',
      messageMode: 'Message Mode',
      msgContent: 'Msg Content',
      messageSubType: 'Message SubType',
      creator: 'Creator',
      creatorTime: 'Creator Time',
      readTime: 'Read Time',
      readFlag: 'Read Flag',
      read: 'Read',
      noRead: 'No Read'
    },
    vesselDynamic: {
      title: 'Vessel Dynamic',
      logLat: 'Loglat',
      long: 'Long',
      wide: 'Wide',
      etaTime: 'Eta Time',
      speed: 'Speed',
      azimuth: 'Azimuth',
      status: 'Sailing Status',
      port: 'Ningbo Port',
      sailing: 'Sailing',
      destination: 'Destination'
    },
    crewList: {
      title: 'Crewlist',
      crewName: 'Crew Name',
      position: 'Position',
      onBoardDate: 'Onboarddate',
      serviceLog: 'Servicelog',
      operation: 'Operation'
    },
    budget: {
      title: "Implementation of this year's budget"
    },
    notCorrected: {
      title: 'NC has not been reformed'
    },
    outDate: {
      title: 'Certificates that have expired and expired within 3 months',
      dept: 'Dept',
      liscence: 'Liscence',
      outDate: 'Out Date'
    },
    exercise: {
      title: 'Progress of emergency drill plan implementation'
    },
    workOrder: {
      title: 'Overdue Work Order'
    },
    building: 'Function Under Construction...',
    authApproval: {
      authorizer: 'Authorizer',
      authorizered: 'Authorized person',
      authorizerTime: 'Authorization time',
      currentStatus: 'Current state',
      authorizerRole: 'Authorization role',
      authorizerModel: 'Authorization module',
      authorizeredRole: 'Authorized person role',
      startTime: 'Authorization start time',
      endTime: 'Authorization end time',
      remark: 'Remark',
      taskCompletedNumber: 'Authorization has been done',
      terminationTime: 'Stop time',
      terminationPeople: 'Terminator',
      authorizeDetail: 'Authorization approval details',
      authorizeResource: 'Authorization permission selection',
      choosedModel: 'Module selected',
      authorizedChoose: 'Authorized person\'s choice',
      role: 'Role',
      chooseAuthorized: 'Select the authorized person',
      no: 'No.',
      account: 'Account',
      nameCn: 'User NameCn',
      nameEn: 'User NameEn',
      choosedUser: 'Selected person',
      authorizeBaseInfo: 'Basic authorization information',
      authorizeDate: 'Authorization date',
      to: 'To',
      authorizeStatus: 'Authorization status',
      invalidAuthorizeTip: 'Whether to terminate this authorization？',
      invalidSuccess: 'Failed successfully',
      plsChooseAuthorizeModel: 'Please select an authorization module',
      plsChooseAuthorized: 'Please select the authorized person',
      authorizedCanNotSelf: 'The authorized person cannot do it for himself',
      dealType: 'Treatment type',
      dealTime: 'Processing time',
      dealOpinion: 'Handling opinions',
      showFile: 'Show attachments',
      taskCompleted: 'Authorization has been done',
      clickToGoTaskCompleted: 'Click to enter the authorized list',
      nodeClickTip: 'The saved authorization role cannot be switched'
    },
    userInfo: {
      accountNameISNull: 'Account Name is not empty',
      accountNameExist: 'Account Name already exists',
      baseInfoTitle: 'BaseInfo',
      accountInfo: 'Login Account',
      userName: 'Account Name',
      activateEmail: 'Activate Email',
      notifyToEmail: 'Notify To Email',
      notifyCcEmail: 'Notify CC Email',
      bookingViewType: 'My Booking List View',
      cardRadio: 'Card Style',
      listRadio: 'List Style',
      passwordInfoTitle: 'Password Management',
      passwordInfo: 'Password',
      confirmPassword: 'Confirm Password',
      successMessage: 'UserInfo change success',
      passwordRules: 'Please input password',
      passwordRules1: 'The password must contain 8 to 30 characters, Must contain uppercase letters+lowercase letters+numbers+special symbols (! @ # ￥%&)',
      passwordRules2: 'Special characters are not allowed in passwords, such as<> ‘ “ : | ? * \\ /',
      confirmPasswordRules: 'Please enter the password for double confirmation',
      errorPasswordRules: 'Two password verifications are inconsistent',
      emailCheckRules: 'NotifyTo email can not be null!',
      emailCheckRules1: 'The maximum length of email format cannot exceed 500',
      emailCheckRules2: 'Please enter the correct email format and multiple mailboxes are connected with English semicolons.',
      submitButton: 'Submit',
      simisCompanyCode: 'Company Code',
      simisCompanyNameCn: 'Company Name Cn',
      simisCompanyNameEn: 'Company Name En'
    },
    billConsigneeApplication: {
      addButton: 'Add',
      editButton: 'Edit',
      deleteButton: 'Delete',
      submitButton: 'Submit ',
      searchButton: 'Search',
      resetButton: 'Reset',
      cancelSubmitButton: 'Cancel Submit ',
      NoTable: 'NO.',
      portTable: 'Port',
      companyName: 'Company Name',
      companyNameCN: 'Company Name(CN)',
      usciTable: 'USCI',
      confirmBookTable: 'Commitment Letter',
      statusTable: 'Status',
      editDialogText: 'Edit',
      operationTable: 'operation',
      addSuccess: 'Add Success',
      editSuccess: 'Edit Success',
      deleteConfirm: 'Confirmation of deletion of the data?',
      deleteMessage: 'Delete Success',
      confirmMessage: 'Confirm Success',
      cancenConfirmMessage: 'Cancel Confirm Success',
      lockSuccess: 'Lock Success',
      unLockSuccess: 'UnLock Success',
      confirmButton: 'Confirm',
      cancelButton: 'Cancel',
      isCancenSubmitText: 'Only records with a pending review status can be unsubmitted',
      isEditText: 'Only the Pending Submission and Cancel Review statuses can be edited',
      isSelectData: 'Please check the table data first',
      isCancelDelText: 'Only the Pending Submission and Cancel Review statuses can be deleted',
      isCancelDelText2: 'There are records that are not 【Pending Submission】、 【Cancel Review】, please check again!',
      isConfirmText: 'There are records that are not 【to be submitted】, please check again!',
      isCancenSubmitText2: 'There are records that are not 【pending review】, please check again!\n'
    },
    editFormDialog: {
      saveButton: 'Save',
      cancelButton: 'Cancel',
      portFormItem: 'Port',
      operationFormItem: 'Company Name',
      operationFormItemCn: 'Company Name(CN)',
      USCI: 'USCI',
      accountNoRule: 'Please input accountNo',
      companyNameRule: 'Please input company Name',
      companyNameCnRule: 'Please input company Name(Cn)',
      usciRule: 'Please input usci'
    },
    childrenUserManage: {
      isAddFive: 'The number of newly added sub accounts cannot exceed 10',
      accountFormItem: 'Account',
      userNameFormItem: 'UserName',
      resetButton: 'Reset',
      searchButton: 'Search',
      addChildrenUserButton: 'Add New User',
      addChildrenUserInfo: 'Create Up To 5 Sub-accounts',
      accountTable: 'Account',
      userNameTable: 'UserName',
      activateTable: 'Activation State',
      lockTable: 'Locked State',
      lastLoginTimeTable: 'Last Login Time',
      operationTable: 'Operation',
      portAndSysemTitle: 'Port Authority + Setting',
      addPortAndUserButton: 'Add Port Privileges + Role',
      roleTypePortTable: 'System Type',
      portName: 'Port',
      officeAbbrev: 'Office',
      portAndOutfitPortTable: 'Role/Port/Organization',
      timePortTable: 'Allotment Of Time',
      activatePortTable: 'Operation',
      accountDialog: 'Account',
      userNameDialog: 'UserName',
      passwordDialog: 'Password',
      confirmPassword: 'Confirm Password',
      resetSuccess: 'Password reset successful, password is:',
      isNotChildren: 'Sub accounts cannot be applied for again',
      addDialogRole: 'Role',
      addDialogPort: 'Port',
      addDialogOrganization: 'Organization',
      accountType: 'Account Type',
      tableNo: 'No.',
      selectWarning: 'Please select the table data first',
      addDialogText: 'Add',
      roleNameCn: 'Role Name Cn',
      roleNameEn: 'Role Name En',
      locked: 'Locked',
      unLocked: 'Unlock',
      resetPasswprd: 'Reset Password',
      editDialogText: 'Edit',
      activateEmail: 'Activate Email'
    },
    dangerousDeclaration: {
      searchButton: 'Search',
      billNumber: 'BLNO',
      shipNameVoyage: 'VVL',
      timeInquiryButton: 'Deadline Inquiry',
      cutTime: 'Cut Off Time',
      searchTitle: 'Query Results',
      goodsTickets: 'Number Of Goods Declaration Votes',
      paperUploadButton: 'Upload Paper Declaration',
      shipWarningInfo: 'Please input the ship name, voyage number, and bill of lading number correctly and upload the paper declaration',
      copyWarningInfo: 'Applied: Received goods declaration EDI; Accepted: Received goods declaration EDI and received electronic packing list information',
      cargoDeclarationReceiptNumber: 'Goods Declaration Receipt Number',
      hazardousDeclarationPaper: 'Dangerous Declaration Paper',
      acceptanceMark: 'Acceptance Mark',
      lockStatus: 'Locking State',
      remarks: 'remarks',
      uploadButton: 'Upload',
      closeButton: 'Close',
      noClickDataWarning: 'Select the table data first',
      blNoWarning: 'blNo is no data',
      noDataWarning: 'Please select a record from the list first',
      doucmentCutTimeDataWarning: 'Please search cutTime first',
      isDelayTimeWarning: 'Exceeding the cut-off date range',
      uploadSuccess: 'Upload Success',
      vesselWarning: 'Please provide the correct vessel name, voyage number, and bill of lading number',
      searchFormDocumentWarning: 'Please select ship name and voyage number',
      searchBlNoWarning: 'BlNo cannot be empty'
    },
    newManifestEDI: {
      shipVoyageName: 'VVL',
      prewiredLock: 'Prewired Lock',
      whetherToSendLoad: 'Whether To Send  Load',
      whetherToSendSuccess: 'Whether To Load Success',
      billNumber: 'Bill Number',
      whetherToSendPreconfigured: 'Whether To Send Preconfigured',
      filterSuborder: 'Filter Suborder',
      actualBoxBolume: 'Actual Box Volume',
      releasedOrNot: 'Released Or Not',
      portOfLoading: 'Port Of Loading',
      beforeSplitting: 'Before Splitting',
      afterSplitting: 'After Splitting',
      searchButton: 'Search',
      resetButton: 'Reset',
      exportEdiButton: 'EDI Send',
      prewired: 'Prewired',
      pass: 'Pass',
      stow: 'Stow',
      masterListNumber: 'Master List Number',
      bookingNumber: 'Booking Number',
      timeOfShipment: 'Time Of Shipment',
      preAllocatedSendingTime: 'Pre-allocated Sending Time',
      clearanceTime: 'Clearance Time',
      LoadSendingTime: 'Load Sending Time',
      WhetherToLoadOvertime: 'Whether To Load Overtime',
      boxVolume: 'Box Volume',
      privilegeCode: 'Privilege Code',
      placeOfOriginArrival: 'Place Of Origin/Arrival',
      placeOfLoading: 'Place Of Loading',
      placeOfLoadingCode: 'Place Of Loading Code',
      EDIFileType: 'EDI File Type',
      chooseEdi: 'Choose EDI',
      descriptionReasonChange: 'Description Reason Change',
      changeRequestContactPhone: 'Change Request Contact Phone',
      fileTypeListForm: 'File Type',
      changeOfManifestReason: 'Reason For Change Of Manifest',
      isSelectFileType: 'Please select the EDI message type first',
      ediSuccess: 'Operation Success.',
      pol: 'Pol',
      vvl: 'Ship Name Voyage',
      inputVvl: 'Please enter the vessel name and voyage',
      inputPol: 'Please enter the port of loading',
      inputCustomsId: 'Please enter the customs code',
      inputDistrictCode: 'Please enter the port of origin/arrival',
      inputLoadPlace: 'Please enter the loading location',
      inputPorFormat: 'Enter the EDI packet type',
      reportTypeRequireValidate: 'Please select a packet type',
      deleteReasonRequireValidate: 'Please select a Reason For Change Of Manifest',
      loadShipTimeRequireValidate: 'Please enter the Load Sending Time',
      changeResonRequireValidate: 'Please enter the Description Reason Change',
      changeContactNameRequire: 'Please enter the Change Request Contact Name',
      changeContactTelRequireValidate: 'Please enter the Change Request Contact Phone',
      originalReleaseShipVoyageName: 'original Release VVL',
      viewEdiFeedBack: 'View EDI FeedBack',
      uploadDgDeclare: 'Upload DG Declare',
      uploadChineseMSDS: 'Chinese MSDS',
      chineseMSDS: 'Chinese MSDS',
      dgDeclare: 'DG Declare',
      uploadSuccess: 'Upload Success',
      uploadChineseMSDSSuccess: 'Chinese MSDS Upload Success'
    },
    searchFile: {
      title: 'Search File',
      companyName: 'Company Name',
      fileName: 'File Name',
      port: 'Port',
      resetButton: 'Reset',
      searchButton: 'Search',
      attachment: 'Attachment',
      updateTime: 'UpdateTime',
      portNameCn: 'Port Name Cn',
      portName: 'Port Name En'
    },
    ediFeedBack: {
      vvl: 'VVL',
      portCode: 'Port Code',
      importTime: 'Import Time',
      vesselAndVoyageNotNull: 'Vessel&Voyage not null',
      blNoNotEmpty: 'B/L NO Not Null',
      vesselCode: 'Vessel Code',
      voyageNo: 'Voyage No',
      voyageLeg: 'Voyage Leg',
      blNo: 'B/L NO',
      content: 'Content',
      createdDate: 'Created Time',
      containerNo: 'Container No',
      messageId: 'Message ID',
      functionCode: 'Function Code',
      messageType: 'Message Type',
      imoCode: 'IMO',
      responseType: 'ResponseType',
      sendTime: 'SendTime',
      portCodeNotNull: 'Port Code Not Null',
      checkOneRecord: 'Please check one record',
      missingData: 'Missing data for selected records',
      btnGuidebook: 'Guide to Handling EDI Sending Failure',
      checkOneData: 'Please select at least one record',
      YPDeleteCNTAO: 'YP Delete(CNTAO)',
      customsCode: 'Customs Code',
      changeApplicantName: 'Change Applicant Name',
      changeApplicantTel: 'Change Applicant Tel',
      changeReason: 'Change Reason',
      validCustomsCode: 'Please select the customs code',
      validChangeApplicantName: 'Please enter the name of the change applicant',
      validChangeApplicantTel: 'Please enter Tel of the change applicant',
      validChangeReason: 'Please enter the reason for the change',
      deleteSuccess: 'Message successfully uploaded to ftp!',
      delFail: 'Failed to upload message to ftp!'
    },
    sendFailGuidebook: {
      title: 'Main feedback content and processing suggestions (for other feedback content, please consult customer service)',
      tabTitle1: '1. No forecasted movement of the means of transportation on the manifest, customs clearance not passed',
      tabTitle2: '2. The report does not meet the specifications for filling in, and the customs audit is not passed',
      tabTitle3: '3. No receipt sent unsuccessfully',
      tabTips1: 'Pre-allocation sending time is too early/customs zone is wrong. Before sending manifests, you can check the ship\'s movement on the customs platform,' + ' usually send manifests within 72 hours before the ship departs, and re-send manifests in the correct customs zone/corresponding time.',
      tabTips2: 'Pre-feedback content in English for a detailed explanation. More than send and receive passes the phone mailbox and other content entry is not standardized, ' + 'pay attention to the characters can not be too long, control in a line within the phone to pure digital form of entry, ' + 'and phone mailbox enterprise code and other information must be one-to-one correspondence, shall not be replaced by other characters such as point. ' + 'Or fill in the seal number is not correct, need to box seal number one-to-one correspondence, record a complete seal, fill in correctly!',
      tabTips3: 'There are more than 256 characters in the name and address field, ' + 'special characters in the name and address field, too long characters in the contact phone and fax field, special characters in the phone/fax field () + -, etc., ' + 'spaces after the seal number and box number, and the contact person\'s phone number is not filled out in the Dangerous Goods Information field.'
    }
  }
};